module.exports = __webpack_public_path__ + "img/driving_licence.55fe9c1c.png";